import { Component, input, signal, effect, output, ViewChild, ElementRef, HostListener, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IconComponent } from 'src/app/@core/components/ui/icon/icon.component';

@Component({
    selector: 'app-image-preview',
    standalone: true,
    imports: [CommonModule, IconComponent],
    templateUrl: './image-preview.component.html',
    styleUrl: './image-preview.component.scss'
})
export class ImagePreviewComponent implements OnDestroy {
    imageUrl = input<string>('');
    onClose = output<void>();

    @ViewChild('overlay', { static: false }) overlay?: ElementRef<HTMLDivElement>;

    visible = signal<boolean>(false);
    constructor() {
        effect(() => {
            const url = this.imageUrl();
            this.visible.set(!!url);
            if (url) {
                // Prevent body scroll when modal is open
                document.body.style.overflow = 'hidden';
            } else {
                // Restore body scroll when modal is closed
                document.body.style.overflow = '';
            }
        });
    }

    ngOnDestroy() {
        // Restore body scroll on component destroy
        document.body.style.overflow = '';
    }

    @HostListener('document:keydown.escape', ['$event'])
    handleEscape(event: KeyboardEvent) {
        if (this.visible()) {
            this.close();
        }
    }

    close() {
        this.onClose.emit();
    }
}

